import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserCredentials, CheckoutCredentials } from '@core/models/userCredentials.interface';
import { AuthService } from '@core/services/auth.service';
import { Observable } from 'rxjs';


export type token = {
  access_token: string
}

@Injectable({
  providedIn: 'root'
})

export class LoginService extends AuthService {

  //private apiUrl: string = 'https://api.ipify.org?format=json';

  constructor(http: HttpClient){
    super(http)
  }


  signIn(url: string, data: UserCredentials): Observable<any> {
    let datos = {
      username: data.username,
      password: data.password
    }
    return this._post(url, datos);
  }

  signInCheckout(url: string, data: CheckoutCredentials): Observable<any> {
    let datos = {
      voucher_log_id: data.voucher_log_id
    }
    return this._post(url, datos);
  }


  logOut(url: string, data: token): Observable<any> {
    let datos = {
      access_token: data.access_token,
    }
    return this._get(url, datos);
  }

  clear() {
    localStorage.clear();
    sessionStorage.clear();
  }

  loggedInGuard() {
		if (localStorage.getItem('AccessToken')) {
			return true;
		} else {
			return false;
		}
	}


  /* getIpAddress(): Observable<{ ip: string }> {
    return this._get(this.apiUrl, {}, true, true);
  } */

}
